module.exports = "/assets/data/3478cc28ae68dfbbf4378348fe411581-SE6.data.json";